import styled from 'styled-components';

const FormStyles = styled.div`
  margin-top: 20px;
  .store-select {
    .ant-select-selector {
      height: auto;
    }
    .store-option-info__icon {
      line-height: 35px;
    }
  }
`;

export const TableProductSelectedStyles = styled.div`
  margin-top: 20px;
  .ant-table-thead th {
    text-align: center;
    background: ${({ theme }) => theme?.background?.headerFormTable} !important;
  }

  .ant-table-row > .ant-table-cell:first-child {
    padding-left: 0;
  }

  .ant-table-row > .ant-table-cell:not(:first-child) {
    //  text-align: center;
  }
`;

export default FormStyles;
